<template>
  <DPDPill class="pill" :label="label" :type="type" @[clickEvent]="$emit('click', $event)" @[removeEvent]="$emit('remove', item)" />
</template>

<script>
import { isString } from '../../../libraries/common';
import { getEventValueLabel } from '../../../libraries/criteria';
import DPDPill from './DPDPill.vue';
export default {
  components: { DPDPill },
  props: ['item'],
  computed: {
    label() {
      return getEventValueLabel(this.item) || this.item;
    },
    type() {
      var type = this.item.type?.toLowerCase();
      return type || (isString(this.item.search) && this.item.search.split('|').last()?.split('/').head().last()?.toLowerCase()) || '';
    },
    clickEvent() {
      return this.$listeners.click ? 'click' : null;
    },
    removeEvent() {
      return this.$listeners.remove ? 'remove' : null;
    },
  },
}
</script>
